      // Wait for Matter.js to be loaded
      function initFlipperGame() {
          if (typeof Matter === 'undefined') {
              setTimeout(initFlipperGame, 100);
              return;
          }

          // Preload images to ensure they're available for Matter.js
          const imageUrls = [
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/shoe-left-big.webp?v=1751548889',
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/shoe-right-big.webp?v=1751548849',
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball.png?v=1751548819',
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-2.png?v=1751548726',
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-3.png?v=1751548749',
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-4.png?v=1751548772',
              'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-5.png?v=1751548795'
          ];

          Promise.all(imageUrls.map(url => {
              return new Promise((resolve, reject) => {
                  const img = new Image();
                  img.onload = () => resolve(url);
                  img.onerror = () => reject(url);
                  img.src = url;
              });
          })).then(() => {
              console.log('All images loaded successfully');
              startGame();
          }).catch((failedUrl) => {
              console.error('Failed to load image:', failedUrl);
              // Continue anyway, but without sprites
              startGame();
          });

          function startGame() {

          // Matter.js setup
          const { Engine, Render, World, Bodies, Body, Composite, Common, Vertices } = Matter;

      // Create engine and world
      const engine = Engine.create();
      const world = engine.world;

      // Function to calculate gravity based on screen width
      const calculateGravity = () => {
          return window.innerWidth < 767 ? 0.4 : 0.4;
      };

      // Function to calculate restitution based on screen width
      const calculateRestitution = () => {
          return window.innerWidth < 767 ? 0.7 : 0.80;
      };

      // Set initial gravity
      engine.gravity.y = calculateGravity();

      // Score system - START
      const scoreSystem = {
          ballScores: new Map(), // Map to store scores for each ball
          ballFirstTouch: new Map(), // Map to track if a ball has had its first touch
          highScore: 0, // Initialize high score to 0 (no localStorage)

          updateScore(ballId) {
              // Get or initialize score for this ball
              if (!this.ballScores.has(ballId)) {
                  this.ballScores.set(ballId, 0);
                  this.ballFirstTouch.set(ballId, true); // Mark as first touch
              }

              // Check if this is the first touch for this ball
              if (this.ballFirstTouch.get(ballId)) {
                  // First touch doesn't count for score
                  this.ballFirstTouch.set(ballId, false);
              } else {
                  // Not first touch, increment score
                  const currentBallScore = this.ballScores.get(ballId);
                  this.ballScores.set(ballId, currentBallScore + 1);

                  // Update high score if current ball score is higher
                  if (currentBallScore + 1 > this.highScore) {
                      this.highScore = currentBallScore + 1;
                  }
              }

              // Update display with highest current score
              this.updateDisplay();
          },

          resetBallScore(ballId) {
              this.ballScores.set(ballId, 0);
              this.ballFirstTouch.set(ballId, true); // Reset first touch flag
              this.updateDisplay();
          },

          updateDisplay() {
              // Find the highest score among all balls currently in the world
              const balls = world.bodies.filter(body => body.circleRadius);
              let highestCurrentScore = 0;

              balls.forEach(ball => {
                  const ballScore = this.ballScores.get(ball.id) || 0;
                  if (ballScore > highestCurrentScore) {
                      highestCurrentScore = ballScore;
                  }
              });

              // Update display
              const currentScoreEl = flipperContainer.querySelector('.mm-flipper-current-score');
              const highScoreEl = flipperContainer.querySelector('.mm-flipper-high-score');

              if (currentScoreEl) currentScoreEl.textContent = highestCurrentScore;
              if (highScoreEl) highScoreEl.textContent = this.highScore;
          }
      };

      // Score system - END

      // Secret code feature - START
      const secretCode = {
          sequence: ['ArrowLeft', 'ArrowLeft', 'ArrowRight', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight'],
          currentIndex: 0,
          isActive: false,
          activate() {
              this.isActive = true;
              console.log('Secret code activated! Special balls unlocked!');
          }
      };

      // Track key presses for secret code
      document.addEventListener('keydown', (event) => {
          if (event.key === secretCode.sequence[secretCode.currentIndex]) {
              secretCode.currentIndex++;
              if (secretCode.currentIndex === secretCode.sequence.length) {
                  secretCode.activate();
                  secretCode.currentIndex = 0;
              }
          } else {
              secretCode.currentIndex = 0;
          }
      });
      // Secret code feature - END

      // Check if flipper game container exists
      const flipperContainer = document.querySelector('.mm-flipper-game');
      if (!flipperContainer) return;

      // Create renderer
      const render = Render.create({
          element: flipperContainer,
          engine: engine,
          options: {
              width: flipperContainer.offsetWidth,
              height: flipperContainer.offsetHeight,
              wireframes: false,
              background: 'transparent',
              pixelRatio: window.devicePixelRatio || 1
          }
      });

      // Function to update canvas size with proper pixel ratio
      function updateCanvasSize() {
          const pixelRatio = window.devicePixelRatio || 1;
          const canvas = render.canvas;

          // Get the actual container dimensions
          const containerWidth = flipperContainer.offsetWidth;
          const containerHeight = flipperContainer.offsetHeight;

          // Set canvas size accounting for pixel ratio
          canvas.width = containerWidth * pixelRatio;
          canvas.height = containerHeight * pixelRatio;

          // Set display size
          canvas.style.width = containerWidth + 'px';
          canvas.style.height = containerHeight + 'px';

          // Scale context
          const context = canvas.getContext('2d');
          context.scale(pixelRatio, pixelRatio);

          // Update render bounds
          render.bounds.max.x = containerWidth;
          render.bounds.max.y = containerHeight;
      }

      // Initial canvas setup
      updateCanvasSize();

      // Function to calculate scale based on screen size
      const calculateScale = () => {
          const baseScale = (flipperContainer.offsetWidth / 635) / 2;
          return flipperContainer.offsetWidth < 767 ? baseScale * 1.1 : baseScale; // 20% bigger on mobile
      };

      // Function to calculate edge padding based on screen width
      const calculateEdgePaddingX = () => {
          if (flipperContainer.offsetWidth < 767) {
              return Math.max(flipperContainer.offsetWidth * 0.05, 10);
          }
          return 50; // Default padding for larger screens
      };

      // Function to calculate edge padding based on screen width
      const calculateEdgePaddingY = () => {
          if (flipperContainer.offsetWidth < 767) {
              return Math.min(Math.max(flipperContainer.offsetWidth * 0.5, 30), 150);
          }
          return 50; // Default padding for larger screens
      };

      // Function to calculate ball scale based on screen size
      const ballsScale = () => {
          const baseBScale = 60;
          return flipperContainer.offsetWidth < 767 ? baseBScale * 0.5 : baseBScale; // 50% smaller on mobile
      };

      // Function to calculate maximum number of balls based on screen width
      const getMaxBalls = () => {
          return flipperContainer.offsetWidth < 767 ? 2 : 3;
      };

      // Create vertices for the ground shape
      let scale = calculateScale();
      let edgePaddingX = calculateEdgePaddingX();
      let edgePaddingY = calculateEdgePaddingY();

      const vertices = [
          { x: 37 * scale, y: 54.5 * scale },
          { x: 0 * scale, y: 268.5 * scale },
          { x: 634.5 * scale, y: 268.5 * scale },
          { x: 633 * scale, y: 169.5 * scale },
          { x: 550 * scale, y: 169.5 * scale },
          { x: 276 * scale, y: 0 * scale }
      ];

      // Create vertices for the right shape
      const rightVertices = [
          { x: 597.5 * scale, y: 54.5 * scale },
          { x: 634.5 * scale, y: 268.5 * scale },
          { x: 0 * scale, y: 268.5 * scale },
          { x: 1.5 * scale, y: 169.5 * scale },
          { x: 358.5 * scale, y: 0 * scale }
      ];

      // Calculate the center points for rotation
      const leftCenterX = edgePaddingX; // Dynamic padding from left
      const leftCenterY = flipperContainer.offsetHeight - edgePaddingY - (134.25 * scale);

      const rightCenterX = flipperContainer.offsetWidth - edgePaddingX; // Dynamic padding from right
      const rightCenterY = flipperContainer.offsetHeight - edgePaddingY - (134.25 * scale);

      // Create ground bodies from vertices
      const leftGround = Bodies.fromVertices(
          leftCenterX,
          leftCenterY,
          [vertices],
          {
              isStatic: true,
              restitution: calculateRestitution(),
              render: {
                  sprite: {
                      texture: 'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/shoe-left-big.webp?v=1751546747',
                      xScale: flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3,
                      yScale: flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3,
                      xOffset: -0.0,
                      yOffset: flipperContainer.offsetWidth < 767 ? 0.08 : 0.12
                  },
                  strokeStyle: '#ff0000',
                  lineWidth: 2
              },
              angle: -20 * Math.PI / 180 // Initial rotation of -20 degrees
          }
      );

      const rightGround = Bodies.fromVertices(
          rightCenterX,
          rightCenterY,
          [rightVertices],
          {
              isStatic: true,
              restitution: calculateRestitution(),
              render: {
                  sprite: {
                      texture: 'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/shoe-right-big.webp?v=1751546747',
                      xScale: flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3,
                      yScale: flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3,
                      xOffset: -0.01,
                      yOffset: flipperContainer.offsetWidth < 767 ? 0.06 : 0.1
                  },
                  strokeStyle: '#ff0000',
                  lineWidth: 2
              },
              angle: 20 * Math.PI / 180 // Initial rotation of 20 degrees
          }
      );

      // Add grounds to world
      World.add(world, [leftGround, rightGround]);

      // Add collision handling for more energetic impacts
      Matter.Events.on(engine, 'collisionStart', function(event) {
          event.pairs.forEach(function(pair) {
              const bodyA = pair.bodyA;
              const bodyB = pair.bodyB;


              // Check if one of the bodies is a ball and the other is a ground
              if ((bodyA.circleRadius && (bodyB === leftGround || bodyB === rightGround)) ||
                  (bodyB.circleRadius && (bodyA === leftGround || bodyA === rightGround))) {


                  // Get the ball body
                  const ball = bodyA.circleRadius ? bodyA : bodyB;

                  // Calculate impact direction based on which ground was hit
                  const impactDirection = ball === bodyA ? pair.collision.normal : pair.collision.normal;

                  // Add extra velocity in the direction of the impact
                  const extraForce = 4; // Reduced from 15 to 8 for more controlled bounces
                  Body.setVelocity(ball, {
                      x: ball.velocity.x + (impactDirection.x * extraForce),
                      y: ball.velocity.y + (impactDirection.y * extraForce)
                  });

                  // Add some angular velocity for more dynamic movement
                  Body.setAngularVelocity(ball, ball.angularVelocity + (Math.random() * 0.1 - 0.05)); // Reduced from 0.2 to 0.1

                  // Update score on ground hit for this specific ball
                  scoreSystem.updateScore(ball.id);
              }
          });
      });

      // Add invisible walls on both sides
      const wallThickness = 20;
      const leftWall = Bodies.rectangle(
          -wallThickness,
          flipperContainer.offsetHeight/2,
          wallThickness,
          flipperContainer.offsetHeight,
          {
              isStatic: true,
              render: { visible: false }
          }
      );

      const rightWall = Bodies.rectangle(
          flipperContainer.offsetWidth + wallThickness,
          flipperContainer.offsetHeight/2,
          wallThickness,
          flipperContainer.offsetHeight,
          {
              isStatic: true,
              render: { visible: false }
          }
      );

      World.add(world, [leftWall, rightWall]);

      // Function to create falling balls
      function createBall() {
          // Check if we've reached the maximum number of balls
          const balls = world.bodies.filter(body => body.circleRadius);
          if (balls.length >= getMaxBalls()) return;

          // Randomly choose left or right side
          const isLeftSide = Math.random() < 0.5;
          let x;

          if (isLeftSide) {
              if (flipperContainer.offsetWidth < 767) {
                  x = Math.random() * 100;
              } else {
              x = Math.random() * 300;
              }
          } else {
              if (flipperContainer.offsetWidth < 767) {
                  x = flipperContainer.offsetWidth - 100 + (Math.random() * 150);
              } else {
              x = flipperContainer.offsetWidth - 300 + (Math.random() * 300);
              }
          }

          const ballSize = ballsScale();
          const spriteScale = ballSize / 60; // Scale sprite relative to ball size

          const ball = Bodies.circle(
              x,
              0,
              ballSize,
              {
                  restitution: calculateRestitution(),
                  friction: 0.2,
                  frictionAir: 0.001,
                  density: 0.05,
                  chamfer: { radius: 5 },
                  collisionFilter: {
                      group: 0,
                      category: 0x0001,
                      mask: 0xFFFFFFFF
                  },
                                        render: {
                          sprite: {
                              texture: secretCode.isActive ? 'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-5.png?v=1751546747' : ['https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball.png?v=1751546747', 'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-2.png?v=1751546747', 'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-3.png?v=1751546747', 'https://cdn.shopify.com/s/files/1/0931/3242/3498/files/ball-4.png?v=1751546747'][Math.floor(Math.random() * 4)],
                              xScale: spriteScale,
                              yScale: spriteScale
                          },
                          strokeStyle: '#ff0000',
                          lineWidth: 2
                      }
              }
          );
          World.add(world, ball);

          // Initialize score for this ball
          scoreSystem.ballScores.set(ball.id, 0);
          scoreSystem.ballFirstTouch.set(ball.id, true); // Mark as first touch
          scoreSystem.updateDisplay();
      }

      // Check for balls going off screen and create new ones
      Matter.Events.on(engine, 'afterUpdate', function() {
          const balls = world.bodies.filter(body => body.circleRadius);
          const maxBalls = getMaxBalls();

          // If we have no balls, create one
          if (balls.length === 0) {
              createBall();
          } else {
              // Check if any ball is off screen from the bottom
              const offScreenBalls = balls.filter(ball =>
                  ball.position.y > flipperContainer.offsetHeight + 100 // Below screen
              );

              if (offScreenBalls.length > 0) {
                  // Remove only the balls that went off screen
                  offScreenBalls.forEach(ball => {
                      // Remove ball from score tracking
                      scoreSystem.ballScores.delete(ball.id);
                      scoreSystem.ballFirstTouch.delete(ball.id);
                      World.remove(world, ball);
                  });

                  // Create new balls to replace the ones that went off screen
                  // But don't exceed the maximum number of balls
                  const remainingBalls = balls.length - offScreenBalls.length;
                  const ballsToCreate = Math.min(offScreenBalls.length, maxBalls - remainingBalls);
                  for (let i = 0; i < ballsToCreate; i++) {
                      createBall();
                  }

                  // Update display after removing balls
                  scoreSystem.updateDisplay();
              }
          }
      });

      // Create initial balls based on screen width
      const initialBalls = getMaxBalls();
      for (let i = 0; i < initialBalls; i++) {
          createBall();
      }

      // Handle keyboard controls
      let isLeftAnimating = false;
      let isRightAnimating = false;
      let isLeftHeld = false;
      let isRightHeld = false;

      document.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' && !isLeftHeld) {
              isLeftHeld = true;
              isLeftAnimating = true;

              // Animate to 60 degrees
              gsap.to({}, {
                  duration: 0.3,
                  ease: "power2.out",
                  onUpdate: function() {
                      const progress = this.progress();
                      const easedProgress = gsap.parseEase("power2.out")(progress);
                      const angle = -20 + (80 * easedProgress); // From -20 to 60
                      Body.setAngle(leftGround, angle * Math.PI / 180);
                      // Update shoe image rotation
                      const shoeLeft = flipperContainer.querySelector('.mm-flipper-shoe-left');
                      if (shoeLeft) {
                          shoeLeft.style.transform = `rotate(${angle}deg)`;
                      }
                  },
                  onComplete: () => {
                      isLeftAnimating = false;
                  }
              });
          } else if (event.key === 'ArrowRight' && !isRightHeld) {
              isRightHeld = true;
              isRightAnimating = true;

              // Animate to -60 degrees
              gsap.to({}, {
                  duration: 0.3,
                  ease: "power2.out",
                  onUpdate: function() {
                      const progress = this.progress();
                      const easedProgress = gsap.parseEase("power2.out")(progress);
                      const angle = 20 - (80 * easedProgress); // From 20 to -60
                      Body.setAngle(rightGround, angle * Math.PI / 180);
                      // Update shoe image rotation
                      const shoeRight = flipperContainer.querySelector('.mm-flipper-shoe-right');
                      if (shoeRight) {
                          shoeRight.style.transform = `rotate(${angle}deg)`;
                      }
                  },
                  onComplete: () => {
                      isRightAnimating = false;
                  }
              });
          }
      });

      document.addEventListener('keyup', (event) => {
          if (event.key === 'ArrowLeft' && isLeftHeld) {
              isLeftHeld = false;
              isLeftAnimating = true;

              // Animate back to -20 degrees with elastic effect
              gsap.to({}, {
                  duration: 0.5,
                  ease: "elastic.out(0.5, 0.3)",
                  onUpdate: function() {
                      const progress = this.progress();
                      const easedProgress = gsap.parseEase("elastic.out(0.5, 0.3)")(progress);
                      const angle = 60 - (80 * easedProgress); // From 60 to -20
                      Body.setAngle(leftGround, angle * Math.PI / 180);
                      // Update shoe image rotation
                      const shoeLeft = flipperContainer.querySelector('.mm-flipper-shoe-left');
                      if (shoeLeft) {
                          shoeLeft.style.transform = `rotate(${angle}deg)`;
                      }
                  },
                  onComplete: () => {
                      isLeftAnimating = false;
                  }
              });
          } else if (event.key === 'ArrowRight' && isRightHeld) {
              isRightHeld = false;
              isRightAnimating = true;

              // Animate back to 20 degrees with elastic effect
              gsap.to({}, {
                  duration: 0.5,
                  ease: "elastic.out(0.5, 0.3)",
                  onUpdate: function() {
                      const progress = this.progress();
                      const easedProgress = gsap.parseEase("elastic.out(0.5, 0.3)")(progress);
                      const angle = -60 + (80 * easedProgress); // From -60 to 20
                      Body.setAngle(rightGround, angle * Math.PI / 180);
                      // Update shoe image rotation
                      const shoeRight = flipperContainer.querySelector('.mm-flipper-shoe-right');
                      if (shoeRight) {
                          shoeRight.style.transform = `rotate(${angle}deg)`;
                      }
                  },
                  onComplete: () => {
                      isRightAnimating = false;
                  }
              });
          }
      });

      // Add touch controls for mobile
      let isLeftPressed = false;
      let isRightPressed = false;

      // Function to handle button press
      function handleButtonPress(key, isPressed) {
          const event = new KeyboardEvent(isPressed ? 'keydown' : 'keyup', { key });
          document.dispatchEvent(event);
      }

      // Left button controls
      const leftButton = flipperContainer.querySelector('.mm-flipper-left-button');
      if (leftButton) {
          const leftButtonCenter = leftButton.querySelector('.mm-flipper-button-center');

          leftButton.addEventListener('touchstart', (e) => {
              e.preventDefault();
              isLeftPressed = true;
              leftButtonCenter.classList.add('pressed');
              handleButtonPress('ArrowLeft', true);
          });

          leftButton.addEventListener('touchend', (e) => {
              e.preventDefault();
              isLeftPressed = false;
              leftButtonCenter.classList.remove('pressed');
              handleButtonPress('ArrowLeft', false);
          });

          // Handle touch cancel events
          leftButton.addEventListener('touchcancel', (e) => {
              e.preventDefault();
              isLeftPressed = false;
              leftButtonCenter.classList.remove('pressed');
              handleButtonPress('ArrowLeft', false);
          });

          // Handle cases where touch moves outside the button
          leftButton.addEventListener('touchmove', (e) => {
              const touch = e.touches[0];
              const buttonRect = leftButton.getBoundingClientRect();
              if (!isPointInRect(touch.clientX, touch.clientY, buttonRect) && isLeftPressed) {
                  isLeftPressed = false;
                  leftButtonCenter.classList.remove('pressed');
                  handleButtonPress('ArrowLeft', false);
              }
          });
      }

      // Right button controls
      const rightButton = flipperContainer.querySelector('.mm-flipper-right-button');
      if (rightButton) {
          const rightButtonCenter = rightButton.querySelector('.mm-flipper-button-center');

          rightButton.addEventListener('touchstart', (e) => {
              e.preventDefault();
              isRightPressed = true;
              rightButtonCenter.classList.add('pressed');
              handleButtonPress('ArrowRight', true);
          });

          rightButton.addEventListener('touchend', (e) => {
              e.preventDefault();
              isRightPressed = false;
              rightButtonCenter.classList.remove('pressed');
              handleButtonPress('ArrowRight', false);
          });

          rightButton.addEventListener('touchcancel', (e) => {
              e.preventDefault();
              isRightPressed = false;
              rightButtonCenter.classList.remove('pressed');
              handleButtonPress('ArrowRight', false);
          });

          rightButton.addEventListener('touchmove', (e) => {
              const touch = e.touches[0];
              const buttonRect = rightButton.getBoundingClientRect();
              if (!isPointInRect(touch.clientX, touch.clientY, buttonRect) && isRightPressed) {
                  isRightPressed = false;
                  rightButtonCenter.classList.remove('pressed');
                  handleButtonPress('ArrowRight', false);
              }
          });
      }

      // Helper function to check if a point is within a rectangle
      function isPointInRect(x, y, rect) {
          return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      }

      // Handle window resize
      window.addEventListener('resize', () => {
          // Update canvas size with proper pixel ratio
          updateCanvasSize();

          // Update gravity based on new width
          engine.gravity.y = calculateGravity();

          // Recalculate scale and padding based on new window width
          scale = calculateScale();
          edgePaddingX = calculateEdgePaddingX();
          edgePaddingY = calculateEdgePaddingY();

          // Update ball sizes on resize and enforce max balls
          const balls = world.bodies.filter(body => body.circleRadius);
          const newBallSize = ballsScale();
          const newSpriteScale = newBallSize / 60;
          const maxBalls = getMaxBalls();

          // Remove excess balls if screen size changed to mobile
          while (balls.length > maxBalls) {
              const ballToRemove = balls.pop();
              scoreSystem.ballScores.delete(ballToRemove.id);
              scoreSystem.ballFirstTouch.delete(ballToRemove.id);
              World.remove(world, ballToRemove);
          }

          // Update remaining balls
          balls.forEach(ball => {
              const scaleFactor = newBallSize / ball.circleRadius;
              Body.scale(ball, scaleFactor, scaleFactor);
              ball.render.sprite.xScale = newSpriteScale;
              ball.render.sprite.yScale = newSpriteScale;
          });

          // Update left ground position and vertices
          const leftCenterX = edgePaddingX;
          const leftCenterY = flipperContainer.offsetHeight - edgePaddingY - (134.25 * scale);
          const leftVertices = [
              { x: 37 * scale, y: 54.5 * scale },
              { x: 0 * scale, y: 268.5 * scale },
              { x: 634.5 * scale, y: 268.5 * scale },
              { x: 633 * scale, y: 169.5 * scale },
              { x: 550 * scale, y: 169.5 * scale },
              { x: 276 * scale, y: 0 * scale }
          ];

          // Update right ground position and vertices
          const rightCenterX = flipperContainer.offsetWidth - edgePaddingX;
          const rightCenterY = flipperContainer.offsetHeight - edgePaddingY - (134.25 * scale);
          const rightVertices = [
              { x: 597.5 * scale, y: 54.5 * scale },
              { x: 634.5 * scale, y: 268.5 * scale },
              { x: 0 * scale, y: 268.5 * scale },
              { x: 1.5 * scale, y: 169.5 * scale },
              { x: 358.5 * scale, y: 0 * scale }
          ];

          // Update left ground
          Body.setPosition(leftGround, { x: leftCenterX, y: leftCenterY });
          Body.setVertices(leftGround, leftVertices);
          leftGround.render.sprite.xScale = flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3;
          leftGround.render.sprite.yScale = flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3;
          leftGround.render.sprite.yOffset = flipperContainer.offsetWidth < 767 ? 0.08 : 0.12;

          // Update right ground
          Body.setPosition(rightGround, { x: rightCenterX, y: rightCenterY });
          Body.setVertices(rightGround, rightVertices);
          rightGround.render.sprite.xScale = flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3;
          rightGround.render.sprite.yScale = flipperContainer.offsetWidth < 767 ? (810 / 635) * scale * 0.4 : (810 / 635) * scale * 0.3;
          rightGround.render.sprite.yOffset = flipperContainer.offsetWidth < 767 ? 0.06 : 0.1;

          // Update wall positions
          Body.setPosition(leftWall, { x: -wallThickness/2, y: flipperContainer.offsetHeight/2 });
          Body.setPosition(rightWall, { x: flipperContainer.offsetWidth + wallThickness/2, y: flipperContainer.offsetHeight/2 });

          // Update wall heights
          Body.scale(leftWall, 1, flipperContainer.offsetHeight / leftWall.bounds.max.y);
          Body.scale(rightWall, 1, flipperContainer.offsetHeight / rightWall.bounds.max.y);
      });

             // Add resize observer for shoe images
       const updateShoePositions = () => {
           const shoeLeft = flipperContainer.querySelector('.mm-flipper-shoe-left');
           const shoeRight = flipperContainer.querySelector('.mm-flipper-shoe-right');

           if (shoeLeft) {
               // Update left shoe position
               if (flipperContainer.offsetWidth >= 767) {
                   // Desktop: original position
                   shoeLeft.style.left = `${leftCenterX - (shoeLeft.offsetWidth / 2)}px`;
                   shoeLeft.style.bottom = `${flipperContainer.offsetHeight - leftCenterY - (shoeLeft.offsetHeight / 2)}px`;
               }
               // Mobile positions are handled by CSS
           }

           if (shoeRight) {
               // Update right shoe position
               if (flipperContainer.offsetWidth >= 767) {
                   // Desktop: original position
                   shoeRight.style.right = `${flipperContainer.offsetWidth - rightCenterX - (shoeRight.offsetWidth / 2)}px`;
                   shoeRight.style.bottom = `${flipperContainer.offsetHeight - rightCenterY - (shoeRight.offsetHeight / 2)}px`;
               }
               // Mobile positions are handled by CSS
           }
       };

      // Create and observe resize
      const resizeObserver = new ResizeObserver(updateShoePositions);
      resizeObserver.observe(flipperContainer);

      // Initial update
      window.addEventListener('load', updateShoePositions);

      // Run renderer
      Render.run(render);

      // Boucle d'animation personnalisée pour Matter.js
      let lastTime = performance.now();
      let accumulator = 0;
      const fixedTimeStep = 1000 / 60; // 16.666 ms

          function animate(time) {
              let delta = time - lastTime;
              lastTime = time;
              accumulator += delta;

              while (accumulator >= fixedTimeStep) {
                  Matter.Engine.update(engine, fixedTimeStep);
                  accumulator -= fixedTimeStep;
              }

              requestAnimationFrame(animate);
          }
          requestAnimationFrame(animate);
      } // End of startGame function
      } // End of initFlipperGame function

      // Start the game
      initFlipperGame();
